import * as React from 'react';
import './index.css';
import { withTranslation } from '@sailor/i18n-mach-pro/lib';
import { HomePageEmptyImgMapping } from '@/src/pages/homepage/home_page_main/utils/constant';
import { Dispatch, RootState } from '@/src/pages/homepage/home_page_main/models/store';
import { connect } from '@wmfe/mach-pro-store';

interface State {
}

const mapStateToProps = (state: RootState, dispatch: Dispatch) => ({
  // 获取Feed流数据请求方法
  fetchFeedListData: dispatch.global.fetchFeedListData,
});

type IProps = ReturnType<typeof mapStateToProps>;

interface Props extends IProps {
  code: number;
}

class Loading extends React.Component<Props, State> {
  width: number = 0;
  height: number =0
  constructor(props: Props) {
    super(props);

    this.width = (Mach.env.screenWidth | 375) / 2;
    this.height = Mach.env.screenWidth * (250.0 / 375.0);
  }

  componentDidMount() {

  }

  onClickButton = () => {
    this.props.fetchFeedListData({ pageNo: 0 });
  }

  renderItem = () => (
    <view className="container">
      <view className="page-container" style={{ width: Mach.env?.screenWidth, height: Mach.env?.screenHeight / 2 }}>
        <image
          src={HomePageEmptyImgMapping[this.props.code]}
          className="preheat-img"
          placeholder="assets://address/empty.png"
          style={{
            width: this.width,
            height: this.height,
          }}
        />
      </view>
    </view>
  )

  render() {
    return this.renderItem();
  }
}

export default connect(mapStateToProps)(withTranslation('', {
  withRef: true
})(Loading));
